import request from "@/requests/request";

export const sendTrackingEvent = async (
  event: ISendTrackingEventRQ | undefined,
) =>
  await request({
    url: "/v1/user-event/send",
    method: "POST",
    body: event,
  });
